export default function Home() {
  const role = localStorage.getItem("userRole") || null;
  return (
    <div className="text-xl text-center">
      <span className="capitalize">{role}</span> Dashboard Page
    </div>
  );
}
